var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.184 1.889L9.885.569a.232.232 0 00-.253-.051.232.232 0 00-.076.051L4.073 6.131a.232.232 0 01-.254.051.232.232 0 01-.075-.05l-1.298-1.32a.232.232 0 00-.254-.052.232.232 0 00-.076.051L.818 6.131a.237.237 0 000 .334L3.744 9.43a.232.232 0 00.253.051.232.232 0 00.076-.051l7.11-7.212a.237.237 0 000-.33z"
  })));
}

export default SvgChecked;